<template>
	<aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme ">
		<div class="app-brand demo">
			<a href="javascript:void(0);" class="app-brand-link">
				<span class="app-brand-logo demo">
					<span style="color: var(--bs-primary)">
						<img :src="logoUrl" :style="logoSize()">
					</span>
				</span>
			</a>
			<a href="javascript:void(0);" class="layout-menu-toggle menu-link text-large ms-auto" @click="closeMenu()">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M8.47365 11.7183C8.11707 12.0749 8.11707 12.6531 8.47365 13.0097L12.071 16.607C12.4615 16.9975 12.4615 17.6305 12.071 18.021C11.6805 18.4115 11.0475 18.4115 10.657 18.021L5.83009 13.1941C5.37164 12.7356 5.37164 11.9924 5.83009 11.5339L10.657 6.707C11.0475 6.31653 11.6805 6.31653 12.071 6.707C12.4615 7.09747 12.4615 7.73053 12.071 8.121L8.47365 11.7183Z" fill-opacity="0.9"></path>
					<path d="M14.3584 11.8336C14.0654 12.1266 14.0654 12.6014 14.3584 12.8944L18.071 16.607C18.4615 16.9975 18.4615 17.6305 18.071 18.021C17.6805 18.4115 17.0475 18.4115 16.657 18.021L11.6819 13.0459C11.3053 12.6693 11.3053 12.0587 11.6819 11.6821L16.657 6.707C17.0475 6.31653 17.6805 6.31653 18.071 6.707C18.4615 7.09747 18.4615 7.73053 18.071 8.121L14.3584 11.8336Z" fill-opacity="0.4"></path>
				</svg>
			</a>
		</div>

		<div class="menu-inner-shadow"></div>

		<ul class="menu-inner py-1">
			<li class="menu-header mt-5">
				<span class="menu-header-text" data-i18n="Apps & Pages">Menu</span>
			</li>

			<li class="menu-item" :class="{ active: $route.name === 'dashboard' }">
				<router-link to="/" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-home-smile-line"></i>
					<div data-i18n="Page 1">Tableau de bord</div>
				</router-link>
			</li>

			<li class="menu-item" :class="{ active: $route.path.includes('/employees') }">
				<router-link to="/employees/list" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-user-line"></i>
					<div data-i18n="Page 1">Salariés</div>
				</router-link>
			</li>

			<li class="menu-item" :class="{ active: $route.path.includes('/trainings') }">
				<router-link to="/trainings/list" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-graduation-cap-line"></i>
					<div data-i18n="Page 1">Formations</div>
				</router-link>
			</li>

			<li class="menu-item" :class="{ active: $route.path.includes('/transactions') }">
				<router-link to="/transactions" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-wallet-fill"></i>
					<div data-i18n="Page 1">Crédits</div>
				</router-link>
			</li>

			<li class="menu-item" :class="{ active: $route.path.includes('/moderations') }" v-if="isGroupAdmin">
				<router-link to="/moderations" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-mail-open-line"></i>
					<div data-i18n="Page 1">Requêtes</div>
				</router-link>
			</li>

			<li class="menu-header mt-5">
				<span class="menu-header-text" data-i18n="Components">Votre société</span>
			</li>

			<li class="menu-item" :class="{ active: $route.name === 'certificates' }">
				<router-link to="/certificates" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-pass-valid-line"></i>
					<div data-i18n="Page 1">Attestations</div>
				</router-link>
			</li>

			<li class="menu-item" :class="{ active: $route.name === 'conventions' }">
				<router-link to="/conventions" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-file-marked-line"></i>
					<div data-i18n="Page 1">Conventions</div>
				</router-link>
			</li>

			<li class="menu-item" :class="{ active: $route.name === 'invoices' }">
				<router-link to="/invoices" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-file-copy-2-line"></i>
					<div data-i18n="Page 1">Factures</div>
				</router-link>
			</li>

			<li class="menu-item">
				<router-link to="/setup-company" class="menu-link" @click="closeMenu">
					<i class="menu-icon tf-icons ri-toggle-line"></i>
					<div data-i18n="Page 1">Paramètres</div>
				</router-link>
			</li>
		</ul>
	</aside>
</template>

<script>
export default {
	name: "MenuComponent",

	data() {
		return {
			domain: null,
		};
	},

	props: {
		isGroupAdmin: {
			type: Boolean,
			default: null
		}
	},

	computed: {
		logoUrl() {
			if (this.domain === '2mtraining.pika-aero.com') {
				return require('@/assets/logo-2mtraining.png');
			} else {
				return require('@/assets/logo.png');
			}
		},
	},

	mounted() {
		this.domain = window.location.hostname;

		console.log(this.domain);

		// Ajoute un événement pour fermer le menu quand on clique en dehors
		document.addEventListener("click", this.handleOutsideClick);
	},
	beforeUnmount() {
		// Supprime l'événement lorsqu'on quitte le composant
		document.removeEventListener("click", this.handleOutsideClick);
	},

	methods: {
		logoSize() {
			if (this.domain === '2mtraining.pika-aero.com') {
				return { width: "50px" };
			} else {
				return { width: "160px" };
			}
		},

		handleOutsideClick(event) {
			const menu = this.$el;
			const isMenuExpanded = this.$store.getters.isMenuExpanded;

			if (menu.contains(event.target) && isMenuExpanded)
				this.$store.dispatch("toggleMenu");
		},
		closeMenu() {
			this.$store.dispatch("toggleMenu");
		}
	}
};
</script>


<style scoped>
/* Ajoutez ici des styles spécifiques au layout si nécessaire */

@media (min-width: 1200px) {
  .layout-menu-toggle {
    display: none !important;
  }
}
</style>